/**
 * Shared invalidation helpers — same key shapes as data/query/keyRegistry.
 */
import type { QueryClient } from '@tanstack/react-query';
import { keys } from './keyRegistry';

export async function invalidateSubscriptionQueries(query_client: QueryClient, customer_id: number): Promise<void> {
  await query_client.invalidateQueries({ queryKey: keys.customer(customer_id).subscription });
}

export async function invalidateCalendarQueriesForCustomer(query_client: QueryClient, customer_id: number): Promise<void> {
  await query_client.invalidateQueries({ queryKey: keys.customer(customer_id).calendarAll });
}

export async function invalidateSubscriptionAndCalendarQueries(query_client: QueryClient, customer_id: number): Promise<void> {
  await Promise.all([
    query_client.invalidateQueries({ queryKey: keys.customer(customer_id).subscription }),
    query_client.invalidateQueries({ queryKey: keys.customer(customer_id).calendarAll }),
  ]);
}

export async function invalidateCalendarMonthForDate(
  query_client: QueryClient,
  customer_id: number,
  date_ymd: string,
): Promise<void> {
  if (date_ymd.length < 7) {
    return;
  }
  const month = date_ymd.slice(0, 7);
  await query_client.invalidateQueries({ queryKey: keys.customer(customer_id).calendar(month) });
}
